module.exports = __webpack_public_path__ + "static/img/插秧机.4f366a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/插秧机.png
// module id = Wtfw
// module chunks = 0